var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgManagingTaxesCase2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 127,
    height: 129,
    viewBox: "0 0 127 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1867_3198)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 31.1047C10 19.4489 19.4489 10 31.1047 10H87.2758C98.9317 10 108.381 19.4489 108.381 31.1047V88.8953C108.381 100.551 98.9317 110 87.2758 110H31.1047C19.4489 110 10 100.551 10 88.8953V31.1047Z",
    fill: "#FBF8F0"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.5 62.0938C64.5938 62.0938 69.0938 63.3125 72.75 64.9062C76.125 66.4062 78.25 69.7812 78.25 73.4375V78.5H40.75V73.4688C40.75 69.7812 42.875 66.4062 46.25 64.9375C49.9062 63.3125 54.4062 62.0938 59.5 62.0938ZM34.5 62.875C37.9375 62.875 40.75 60.0625 40.75 56.625C40.75 53.1875 37.9375 50.375 34.5 50.375C31.0625 50.375 28.25 53.1875 28.25 56.625C28.25 60.0625 31.0625 62.875 34.5 62.875ZM38.0312 66.3125C36.875 66.125 35.7188 66 34.5 66C31.4062 66 28.4688 66.6562 25.8125 67.8125C23.5 68.8125 22 71.0625 22 73.5938V78.5H36.0625V73.4688C36.0625 70.875 36.7812 68.4375 38.0312 66.3125ZM84.5 62.875C87.9375 62.875 90.75 60.0625 90.75 56.625C90.75 53.1875 87.9375 50.375 84.5 50.375C81.0625 50.375 78.25 53.1875 78.25 56.625C78.25 60.0625 81.0625 62.875 84.5 62.875ZM97 73.5938C97 71.0625 95.5 68.8125 93.1875 67.8125C90.5312 66.6562 87.5938 66 84.5 66C83.2812 66 82.125 66.125 80.9688 66.3125C82.2188 68.4375 82.9375 70.875 82.9375 73.4688V78.5H97V73.5938ZM59.5 41C64.6875 41 68.875 45.1875 68.875 50.375C68.875 55.5625 64.6875 59.75 59.5 59.75C54.3125 59.75 50.125 55.5625 50.125 50.375C50.125 45.1875 54.3125 41 59.5 41Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1867_3198",
    x: 0.151122,
    y: 0.151122,
    width: 126.521,
    height: 128.14,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 7.03491,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_1867_3198"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4.22095,
    dy: 4.22095
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.51746
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1867_3198"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1867_3198",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgManagingTaxesCase2);
export default __webpack_public_path__ + "static/media/ManagingTaxesCase2.c816af9d29c3e4b002acafad9b061d14.svg";
export { ForwardRef as ReactComponent };